import Button from "components/base/Button/Button";
import PropTypes from "prop-types";
import { Col, Row } from "react-bootstrap";
import styles from "./styles.module.scss";

interface DialogProps {
  message: string;
  onConfirm: () => void;
  onCancel: () => void;
  children: JSX.Element[] | JSX.Element;
}

const Dialog = ({ message, onConfirm, onCancel, children }: DialogProps) => {
  return (
    <div className={styles.dialogCard} data-testid="dialog">
      <h3>{message} </h3>
      <div className={styles.bodyWrapper}>{children}</div>
      <div className="mt-4">
        <Row>
          <Col xs="6">
            <Button variant="secondary" title="Cancel" onClick={onCancel} />
          </Col>
          <Col xs="6">
            <Button variant="primary" title="Yes" onClick={onConfirm} />
          </Col>
        </Row>
      </div>
    </div>
  );
};

Dialog.propTypes = {
  message: PropTypes.string.isRequired,
  onConfirm: PropTypes.func,
  onCancel: PropTypes.func,
  children: PropTypes.element
};

export default Dialog;
